import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { DragAndDropEventArgs, NodeSelectEventArgs } from '@syncfusion/ej2-angular-navigations';
import { sla, slaInteraction, slakpiInteraction } from './../../../models/slakpi';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { DataManager, Query, ReturnOption, Predicate } from '@syncfusion/ej2-data';
import Swal from 'sweetalert2';
import { UserService } from './../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToasterService } from '../../../toaster.service';

@Component({
  selector: 'app-sla-interaction.component',
  templateUrl: './sla-interaction.component.html',
  styleUrls: ['./sla-interaction.component.css']

})
export class SLAInteractionComponent implements OnInit {
  public sla_data: any;
  public interaction_data: any;
  public sla_interaction_data_temp: any;
  public sla_interaction_data: any;
  public permission: number = 1;

  // Mapping TreeView fields property with data source properties
  public fields_sla: Object;
  public fields_interaction: Object;
  public checkNodes: Object[] = [];
  public allowDragAndDrops: boolean = true;
  public objSLAArr: slaInteraction;
  public selected_slaUno: number = 0;
  public selected_slaPUno: number = 0;
  public isRemoveActive: boolean = false;
  public isMapActive: boolean = false;
  @ViewChild("inputObj_SLA", { static: false }) inputObj_SLA: ElementRef;
 
  @ViewChild("inputObj_Tree", { static: false }) inputObj_Tree: ElementRef;

  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;

  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  constructor(public restApi: SLAKPIApiService, public adminService: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService,private userService: UserService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;     
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.Refresh_PageData();
  }

  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("SLA Interaction");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;
        
        //User rights
        //this.editSettings = { allowEditing: this.permision_edit, allowAdding: this.permision_add, allowDeleting: this.permision_delete, mode: 'Dialog' };
        //this.toolbar = this.userService.getRights_Toolbar(this.permision_add, this.permision_edit, this.permision_delete);

      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }

  // Get sla list
  loadSLA() {
    this.spinner.show();
    let inpValue = new sla();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getSLAs(inpValue)
      .subscribe(data => {
        
        this.sla_data = data;
        this.sla_interaction_data_temp = data;
        this.fields_sla = { dataSource: this.sla_data, id: 'strSLAUno', text: 'slaNameCode', child: 'child', iconCss: 'icon' };  
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  public nodeDropped(args: DragAndDropEventArgs): void {
   
  }
   
  public nodeDrag(args: DragAndDropEventArgs): void {
    
    if (!this.permision_edit && !this.permision_add) args.dropIndicator = 'e-no-drop';

    if (args != null && args.droppedNodeData != null) {
      if (args.droppedNodeData.id.toString().toLowerCase().indexOf("s") > -1) {
        args.dropIndicator = 'e-no-drop';
      }
      if (args.draggedNodeData.id.toString().toLowerCase().indexOf("i") > -1) {
        args.dropIndicator = 'e-no-drop';
      }
    }
    else if (args != null) {
      args.dropIndicator = 'e-no-drop';
    }
  }
  public dragStop(args: DragAndDropEventArgs): void {
    if (!this.permision_edit && !this.permision_add) { args.cancel = true; return;} 
    this.isRemoveActive = false;
    if (args != null && args.droppedNodeData != null && args.dropIndicator == "e-drop-in") {
      if (args.draggedNodeData.id.toString().toLowerCase().indexOf("i") > -1) {
        args.cancel = true;
        return;
      }
      if (args.draggedNodeData.id.toString().toLowerCase().indexOf("s") > -1) {
        if (args.droppedNodeData.id.toString().toLowerCase().indexOf("s") > -1) {
          args.cancel = true;
          return;
        }
        else {
                
          if (!this.check_duplicateSLA(args.draggedNodeData.id.toString(), args.droppedNodeData.id.toString())) {
            
            args.cancel = false;
            this.AddEditSLA_Array(args.draggedNodeData.id.toString(), args.droppedNodeData.id.toString());
            return;
            
          }
          else {
            args.cancel = true;
            //Swal.fire('Error', 'Duplicates are not allowed', 'warning');
            this.toaster.show('warning', 'Warning', 'Duplicates are not allowed.');
            return;
          }
          
        }
        
      }
    }
    else if (args != null) {
      args.cancel = true;
      return;
    }
  }

  check_duplicateSLA(dataSLA: string, dataInteraction: string) {
    var rtnchkval = false;
    var filteredArray = this.interaction_data.filter(function (intData) {
    
      if ((intData.pUno != null && (intData.pUno.toLocaleLowerCase() == dataInteraction.toLocaleLowerCase())) && intData.uno.toLocaleLowerCase() == dataSLA.toLocaleLowerCase()) {
        rtnchkval = true;
      }
    });

    return rtnchkval;
  }

  public onNodeSelecting(args: NodeSelectEventArgs): void {
    let id: any = args.nodeData.id;
    let pid: any = args.nodeData.parentID;
    
    if (id.indexOf('S_') >= 0 || id.indexOf('s_') >= 0) {
      this.selected_slaUno = id.replace('s_', '').replace('S_', '');
      this.selected_slaPUno = pid.replace('i_', '').replace('I_', '');
      this.isRemoveActive = true;
      this.isMapActive = false;
    }
      

  }

  AddEditSLA_Array(dataSLA: string, dataInteraction: string) {

    dataSLA = dataSLA.replace('s_', '').replace('S_', '');
    dataInteraction = dataInteraction.replace('i_', '').replace('I_', '');
    let objSLA = new slaInteraction();
    objSLA.slaInteractionUno = 0;
    objSLA.interactionUno = parseInt(dataInteraction);
    objSLA.slaUno = parseInt(dataSLA);
    objSLA.userUno = this.login_UserID;
    objSLA.tenantUno = 1;

    this.objSLAArr.objslaInteraction.push(objSLA);
    this.isRemoveActive = false;
    this.isMapActive = true;
    
    this.loadSLA(); 
  }

  AddEditSLA() {
    
    this.isMapActive = false;
    //dataSLA = dataSLA.replace('s_', '').replace('S_', '');
    //dataInteraction = dataInteraction.replace('i_', '').replace('I_', '');
    //let objSLA = new slaInteraction();
    //objSLA.slaInteractionUno = 0;
    //objSLA.interactionUno = parseInt(dataInteraction);
    //objSLA.slaUno = parseInt(dataSLA);
    //objSLA.userUno = 2;
    //objSLA.tenantUno = 1;
    if (this.objSLAArr.objslaInteraction.length <= 0) {
      //Swal.fire('Error', 'SLA are not mapped ', 'warning');
      this.toaster.show('warning', 'Warning', 'SLA are not mapped');
      this.objSLAArr = new slaInteraction();
    }
    else {
      
      Swal.fire({
        title: '',
        text: 'Please confirm to update',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.objSLAArr.userUno = this.login_UserID;
          this.restApi.addSlaInteractions(this.objSLAArr)
            .subscribe(data => {
              
              this.objSLAArr = new slaInteraction();
              if (data != null && data != undefined && data != '') {
               // Swal.fire('Error', 'Something went wrong', 'error')
                this.toaster.show('error', 'Error', 'Something went wrong.');
              }
              else {

                this.toaster.show('success', 'Success', 'SLA Updated.');
                //Swal.fire({
                //  type: 'success',
                //  title: 'SLA Updated',
                //  showConfirmButton: false,
                //  timer: 1500
                //})
                this.Refresh_PageData();
              }


              this.spinner.hide();
            },
              (error) => {
                //Called when error
                this.objSLAArr = new slaInteraction();
                this.spinner.hide();
              }
            ).add(() => {
              //Called when operation is complete (both success and error)
              this.objSLAArr = new slaInteraction();
              this.spinner.hide();
            });

          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          
          return;
        }
      })

      


    }
    return true;
  
  }

  
  DeleteSLA_Interaction() {
    if (this.selected_slaUno > 0) {
      this.isRemoveActive = false;
      Swal.fire({
        title: '',
        text: 'Please confirm to delete',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
     
          let objsla = new slaInteraction();          
          objsla.slaUno = this.selected_slaUno;
          objsla.interactionUno = this.selected_slaPUno;
          objsla.userUno = this.login_UserID;
          objsla.tenantUno = 1;

          this.restApi.deleteSlaTransaction(objsla)
            .subscribe(data => {

              if (data != null && data != undefined && data != '') {
                this.toaster.show('error', 'Error', 'Something went wrong.');
                //Swal.fire('Error', 'Something went wrong', 'error')
              }
              else {
                this.toaster.show('success', 'Success', 'SLA deleted.');
                //Swal.fire({
                //  type: 'success',
                //  title: 'SLA deleted.',
                //  showConfirmButton: false,
                //  timer: 1500
                //})
                this.Refresh_PageData();

              }


              this.spinner.hide();
            },
              (error) => {
                //Called when error
                this.spinner.hide();
              }
            ).add(() => {
              //Called when operation is complete (both success and error)
              this.spinner.hide();
            });

          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {

          return;
        }
      });


    }
    

  }

  Refresh_PageData() {
    this.objSLAArr = new slaInteraction();
    this.loadSLA();
    this.loadInteractions();
    this.isRemoveActive = false;
    this.isMapActive = false;
    this.selected_slaUno = 0;
    this.selected_slaPUno = 0;
    if (this.inputObj_Tree != undefined && this.inputObj_Tree.nativeElement!=undefined)
      this.inputObj_Tree.nativeElement.value = "";
    if (this.inputObj_SLA != undefined && this.inputObj_SLA.nativeElement!=undefined)
    this.inputObj_SLA.nativeElement.value =""
  }
  changeDataSource_SLA(data) {
    
    this.fields_sla = { dataSource: data, id: 'strSLAUno', text: 'slaNameEn', child: 'child', iconCss: 'icon' };  //selected: 'isSelected', type: 'type'
  }
  //Filtering the TreeNodes
  searchNodes_SLA() {
   
    let _text = this.inputObj_SLA.nativeElement.value;
    
    let predicats = [], _array = [], _filter = [];
    if (_text.trim() == "") {
      this.changeDataSource_SLA(this.sla_data);
    }
    else if (_text.trim().length>1) {
      let predicate = new Predicate('slaNameEn', 'contains', _text, true);
      let filteredList = new DataManager(this.sla_data).executeLocal(new Query().where(predicate));    
      if (filteredList.length == 0) {
        this.changeDataSource_SLA([]);
      } else {
        this.changeDataSource_SLA(filteredList);
      }
    }
  }

  changeDataSource_Tree_interaction(data) {    
    this.fields_interaction = { dataSource: data, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };
  }
  //Filtering the TreeNodes
  searchNodes_Interaction() {
    
    let _text = this.inputObj_Tree.nativeElement.value;

    let predicats = [], _array = [], _filter = [];
    if (_text.trim() == "") {
      this.changeDataSource_Tree_interaction(this.interaction_data);
    }
    else if (_text.trim().length > 1) {
      let predicate = new Predicate('name', 'contains', _text.trim(), true);
      let filteredList = new DataManager(this.interaction_data).executeLocal(new Query().where(predicate));

      for (var j = 0; j < filteredList.length; j++) {
        _filter.push(filteredList[j]["uno"]);
        var filters = this.getFilterItems(filteredList[j], this.interaction_data);
        for (var i = 0; i < filters.length; i++) {
          if (_array.indexOf(filters[i]) == -1 && filters[i] != null) {
            _array.push(filters[i]);
            predicats.push(new Predicate('uno', 'equal', filters[i], false));
          }
        }
      }
      if (filteredList.length == 0) {
        this.changeDataSource_Tree_interaction([]);
      } else {
        let query = new Query().where(Predicate.or(predicats));
        let newList = new DataManager(this.interaction_data).executeLocal(query);
        this.changeDataSource_Tree_interaction(newList);

      }
      
    }
  }

  //Find the Parent Nodes for corresponding childs
  getFilterItems(fList, list) {
    
    let nodes = [];
    nodes.push(fList["uno"]);
    let query2 = new Query().where('uno', 'equal', fList["pUno"], false);
    let fList1 = new DataManager(list).executeLocal(query2);
    if (fList1.length != 0) {
      let pNode = this.getFilterItems(fList1[0], list);
      for (var i = 0; i < pNode.length; i++) {
        if (nodes.indexOf(pNode[i]) == -1 && pNode[i] != null)
          nodes.push(pNode[i]);
      }
      return nodes;
    }
    return nodes;
  }


  // Get Interaction list
  loadInteractions() {
    
    this.spinner.show();
    let inpValue = new slakpiInteraction();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getSlaInteractions(inpValue)
      .subscribe(data => {
        
        this.interaction_data = data;    
        this.fields_interaction = { dataSource: this.interaction_data, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
}
